import "jquery-validation";
import "jquery-validation-unobtrusive";

/* Bootstrap 5 Customization */
export function setValidatorOptions(){

    console.log('[form-validation] Configuring JQuery Validation');

    if ($.validator && $.validator.unobtrusive) {
        console.log('[form-validation] Setting default validation options');

        const settings = {
            validClass: "is-valid",
            errorClass: "is-invalid",
            ignore: ':hidden, .novalidate',
            showErrors: function (errorMap: any, errorList: any[]) {
                // If we have any errors, send out a 'form-invalid' event
                if (errorList.length) {
                    //@ts-ignore
                    document.dispatchEvent(new CustomEvent('form-invalid', { 'detail': { 'form': this.currentForm.id } }));
                }
                //@ts-ignore
                this.defaultShowErrors();
            }
        };

        $.validator.setDefaults(settings);
         //@ts-ignore
        $.validator.unobtrusive.options = settings;       
    }
    else {
        console.warn('$.validator is not defined. Please load this library **after** loading jquery.validate.js and jquery.validate.unobtrusive.js');
    }
}

